<template>
  <a class="item" :href="props.link" target="_blank">
    <AvatarImage :size="20" :src="props.image" />
    <span class="item__name">{{ props.name }}</span>
    <span class="item__ticker">{{ props.ticker }}</span>
  </a>
</template>

<script setup>
  import { Props } from './props';
  //---------------------
  import { AvatarImage } from '@/Groups/Briefcase/private/imports/externalTemplates';
  //---------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>
